import { Component, ContentChildren, HostListener, Input, QueryList } from '@angular/core';

import { FooterButtonsDirective } from '../../services/sticky-footer/footer-buttons.directive';

import { AdditionalInfoAreaComponent } from './additional-info-area/additional-info-area.component';

@Component({
  selector: 'tur-sticky-footer',
  templateUrl: './sticky-footer.component.html',
  styleUrls: ['./sticky-footer.component.scss'],
  imports: [AdditionalInfoAreaComponent],
})
export class StickyFooterComponent {
  @Input() public additionalInfo: string;
  @Input() public beInfos: string;
  @Input() public uiInfos: string;

  @ContentChildren(FooterButtonsDirective)
  public buttons: QueryList<FooterButtonsDirective>;
  public isOpen: boolean;

  public toggleDropdown(): void {
    this.isOpen = !this.isOpen;
  }

  @HostListener('window:resize')
  public onWindowResize(): void {
    this.isOpen = false;
  }
}
